// Core imports
import { z } from "zod";

/**
 * Tool Schema
 * @description Schema for defining tools in an assistant
 * @param {string} name - The name of the tool
 * @param {string} description - The description of the tool
 * @param {string} category - The category of the tool
 * @param {string} icon - The icon of the tool
 * @param {string} runInstructions - The instructions for running the tool
 * @param {object} definition - The definition of the tool
 * @param {string} type - The type of the tool
 * @param {object} function - The function of the tool
 * @param {object} config - The config of the tool
 */
export const ToolSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  category: z.string(),
  icon: z.string(),
  runInstructions: z.string(),
  type: z.string(),

  definition: z.object({
    type: z.literal("function"),
    function: z.object({
      name: z.string(),
      description: z.string(),
      parameters: z.object({
        type: z.literal("object"),
        properties: z.record(z.any()),
        required: z.array(z.string()).optional(),
      }),
    }),
  }),
  execute: z.function(),
});

export default ToolSchema;
